import React, {useState} from 'react';

import {postRequest} from "../routes/Routes";

import '../assets/css/Login.css';

import logo from "../assets/images/logo.svg";

function ForgotPassword() {
    const [inputs, setInputs] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState({});

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }

    const forgotPasswordFunction = (event) => {
        setLoading(true);
        event.preventDefault();
        let values = {
            dto: {
                email: event.target.email.value,
            },
            context: {
                action: 'Forgot Password'
            },
            endpoint: '/api/user/forgot/password'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                setSuccess(values => ({...values, success: true, message: 'Successfully sent forgot password email'}));
            } else {
                setError(values => ({
                    ...values,
                    error: true,
                    errorMessage: response.data.message ? response.data.message : "An error occurred!"
                }));
            }
            setLoading(false);
        });
    }

    return (
        <div className="main">
            <div className='sub-main'>
                <form onSubmit={forgotPasswordFunction}>
                    <div className='img'>
                        <img src={logo} alt="Logo"/>
                    </div>
                    <div>
                        <p className='heading'>Password Reset</p>
                        <p className='description'>Enter your email and we will send you a reset link</p>
                    </div>
                    <div className="login-input-container">
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" className="form-control login-input" name="email"
                                   value={inputs.email || ""} placeholder="Type your email" onChange={handleChange}
                                   required/>
                        </div>
                    </div>
                    {success.success &&
                    <div className="alert login-alert alert-success" role="alert">
                        {success.message}
                    </div>}
                    {error.error &&
                    <div className="alert login-alert alert-danger" role="alert">
                        {error.errorMessage}
                    </div>}
                    <div>
                        <button type="submit" className='black-button login-button' disabled={loading}>
                            {loading ?
                                <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                      aria-hidden="true"/>
                                : null
                            }
                            Send me the link
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ForgotPassword;
